import gql from 'graphql-tag.macro';

const getNotificationsQuery = gql`
  query getNotifications {
    recentNotifications {
      id
      message
      updatedAt
      createdAt
      read
      job {
        id
        jobRequest {
          id
        }
      }
    }
  }
`;

const reducer = (payload) => payload.recentNotifications;

export const getNotifications = {
  query: getNotificationsQuery,
  reducer,
};
